import moment from 'moment';
import 'moment-business-days';

/**
 * Calcule la date de Pâques pour une année donnée
 * @param {number} year - Année
 * @returns {moment} Date de Pâques
 */
function getEasterDate(year) {
	const f = Math.floor;
	const G = year % 19;
	const C = f(year / 100);
	const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
	const I = H - f(H / 28) * (1 - f(H / 28) * f(29 / (H + 1)) * f((21 - G) / 11));
	const day = I - ((year + f(year / 4) + I + 2 - C + f(C / 4)) % 7) + 28;
	const month = 3 + f(day / 31);
	const date = f(day % 31) + 1;
	return moment(`${year}-${month}-${date}`, "YYYY-M-D");
}

/**
 * Génère la liste des jours fériés français pour une année donnée
 * @param {number} year - Année
 * @returns {Array<string>} Liste des jours fériés au format MM-DD
 */
function getFrenchHolidays(year) {
	// Jours fériés fixes
	const fixedHolidays = [
		'01-01', // Jour de l'An
		'05-01', // Fête du Travail
		'05-08', // Victoire 1945
		'07-14', // Fête Nationale
		'08-15', // Assomption
		'11-01', // Toussaint
		'11-11', // Armistice
		'12-25'  // Noël
	];
	
	// Jours fériés mobiles (basés sur Pâques)
	const easter = getEasterDate(year);
	const mobileHolidays = [
		easter.clone().add(1, 'days').format('MM-DD'), // Lundi de Pâques
		easter.clone().add(39, 'days').format('MM-DD'), // Ascension
		easter.clone().add(50, 'days').format('MM-DD')  // Lundi de Pentecôte
	];
	
	return [...fixedHolidays, ...mobileHolidays];
}

const currentYear = moment().year();
const holidays = getFrenchHolidays(currentYear);

moment.updateLocale('fr', {
	holidays,
	holidayFormat: 'MM-DD'
});

export function ConvertObjectToUrlParams(baseUrl, object) {
	const url = Object.entries(object).map(([key, val]) => val ? `${key}=${val}&` : "").join("");
	return `${baseUrl}?${url}`;
}

export function ConvertObjectToParams(baseUrl, object) {
	const url = Object.entries(object).map(([key, val]) => val ? `${key}=${val}&` : "").join('');
	return `${baseUrl}&${url}`;
}

export function ConvertStringToFloat(string) {
	return parseFloat(string).toFixed(2) + " €";
}

/**
 * Calcule le nombre de jours ouvrés entre deux dates (exclut weekends et jours fériés)
 * Utilise moment-business-days pour une gestion complète des jours fériés
 * @param {Date|moment} startDate - Date de début
 * @param {Date|moment} endDate - Date de fin
 * @returns {number} Nombre de jours ouvrés
 */
export function getBusinessDaysBetween(startDate, endDate) {
	const start = moment(startDate);
	const end = moment(endDate);

	const startYear = start.year();
	const endYear = end.year();

	if (startYear !== endYear) {
		const allHolidays = [];
		for (let year = startYear; year <= endYear; year++) {
			allHolidays.push(...getFrenchHolidays(year));
		}
		moment.updateLocale('fr', {
			holidays: allHolidays,
			holidayFormat: 'MM-DD'
		});
	}

	const locale = 'fr';
	const startMoment = start.locale(locale);
	const endMoment = end.locale(locale);

	// 1️⃣ Nombre de jours ouvrés "entiers"
	let businessDays = startMoment.businessDiff(endMoment);

	// 2️⃣ Calcul du delta d’heures exact entre les deux dates
	const totalHours = endMoment.diff(startMoment, 'hours', true);
	const fractionalDays = totalHours / 24;

	// 3️⃣ Si les deux dates sont sur des jours ouvrés, on garde la fraction exacte
	if (startMoment.isBusinessDay() && endMoment.isBusinessDay()) {
		return fractionalDays;
	}

	// 4️⃣ Sinon, on garde le calcul en jours ouvrés entiers
	return businessDays;
}
